import React, { useEffect, useState, useRef } from 'react';
import { CiEdit } from "react-icons/ci";
import { AiOutlineDelete } from "react-icons/ai";
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import { useForm } from "react-hook-form";
import { ToastContainer } from 'react-toastify';
import HttpHelper from '../../service/httpService'
import DashboardWrapper from './DashboardWrapper';
import { RxCross1, RxCross2 } from 'react-icons/rx';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission } from "../../service/userService";
import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";


const SecurityObjectName = 'Website.News';

const DashboardNews = (props) => {

    const {
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Subscript,
        Superscript,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
        Indent,
        Outdent,
        OrderedList,
        UnorderedList,
        Undo,
        Redo,
        FontSize, FontName,
        FormatBlock,
        Link,
        Unlink,
        ViewHtml,
        InsertTable,
        AddRowBefore,
        AddRowAfter,
        AddColumnBefore,
        AddColumnAfter,
        DeleteRow,
        DeleteColumn,
        DeleteTable,
        MergeCells,
        SplitCell,
    } = EditorTools;

    const editor = useRef();
    const [contentData, setContentData] = useState("");

    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);

    const [news, setNews] = useState({});
    const [isHeaderSection, setIsHeaderSection] = useState({});
    const [showLoader, setShowLoader] = useState(false);
    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, clearErrors } = useForm({});
    const formRef = useRef();
    const [isEditing, setIsEditing] = useState(false);
    const [newsIdUpdate, setNewsIdUpdate] = useState(0);
    const [fileIdUpdate, setFileIdUpdate] = useState();
    const [fileDetailsUpdate, setFileDetailsUpdate] = useState();
    const [rowVersion, setRowVersion] = useState('');
    const [primaryKeyEncrypted, setPrimaryKeyEncrypted] = useState('');
    const [imageCurrentShow, setImageCurrentShow] = useState('');
    const [showImgPopup, setShowImgPopup] = useState(false);

    const AccordianHandle = useRef();
    const [accordianStatus, setAccordianStatus] = useState('0');

    const onSubmit = async (data, event) => {
        setLoaderApi(true);
        if (isEditing === true) {
            if (data && data.file && data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("News/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        delete data.file;
                        if (newsIdUpdate !== '') {
                            updateNews(data, newsIdUpdate, fileIdUpdate, response.data[0], data.FileId);
                        }
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                })
            } else {
                updateNews(data, newsIdUpdate, fileIdUpdate, fileDetailsUpdate, false);
            }
        } else {

            if (data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("News/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        delete data.file;
                        addNews(data, data.FileId)
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                })
            }
        }

    };

    const addNews = async (data, fileId) => {

        if (fileId) {
            await HttpHelper.post("News", data).then((response) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
                setIsEditing(true);
                props.showToast('success', 'Record Added Succesfully');
                getNewsList();
                BlankDetails();
            }).catch((error) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
            })
        } else {
            await HttpHelper.post("News", data).then((response) => {
                setIsEditing(true);
                setLoaderApi(false);
                setPopupAddEdit(false);
                props.showToast('success', 'Record Added Succesfully');
                getNewsList();
                BlankDetails();
            }).catch((error) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
            })
        }

    }

    const updateNews = async (data, newsIdUpdate, fileId, fileDetails, hasFile) => {
        //Sandeep: Get the header order on top always.
        if (isHeaderSection) {
            setValue('order', -99);
            Object.assign(data, { isHeaderSection: true });
        }

        if (hasFile) {
            Object.assign(data,
                { rowVersion: rowVersion },
                { primaryKeyEncrypted: primaryKeyEncrypted },
                { NewsId: newsIdUpdate },
                { FileId: fileId },
                { file: fileDetails }
            );
            await HttpHelper.put("News", data).then((response) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
                setIsEditing(true);
                if (response.status === 200) {
                } else {
                    console.log('error while uploading the image');
                }
                getNewsList();
                BlankDetails();
                props.showToast('success', 'Record Updated Succesfully');
            }).catch((error) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
            })
        } else {
            Object.assign(data,
                { rowVersion: rowVersion },
                { primaryKeyEncrypted: primaryKeyEncrypted },
                { NewsId: newsIdUpdate },
                { FileId: fileIdUpdate }
            );
            delete data.file;
            await HttpHelper.put("News", data).then((response) => {
                setIsEditing(true);
                setLoaderApi(false);
                setPopupAddEdit(false);
                if (response.status === 200) {
                } else {
                    console.log('error while uploading the image');
                }
                getNewsList();
                BlankDetails();
                props.showToast('success', 'Record Updated Succesfully');
            }).catch((error) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
            })
        }

    }

    const getNewsList = async (data) => {
        setLoaderApi(true);
        setIsEditing(true);
        await HttpHelper.get("News", data).then((response) => {
            setNews(response.data.data);
            getAllPermission();
            setLoaderApi(false);
            setIsEditing(true);

        }).catch((error) => {
            console.log(error);
        })

    }

    const DeleteUploadedFile = async (fileId) => {
        await HttpHelper.delete("News/DeleteFileAsync?fileId=" + fileId).then((res) => {
            if (res.status === 200) {
                console.log('file deleted successfully', fileId);
            } else {
                console.log(res.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }

    const getNews = async (id) => {

        setIsEditing(true);
        setShowLoader(true);
        setPopupAddEdit(true);
        setLoaderApi(true);

        await HttpHelper.get("News/" + id).then((response) => {
            setIsHeaderSection(response.data.isHeaderSection);
            setValue('Heading', response.data.heading);
            setValue('Content', response.data.content);
            setValue('file', response.data.file);
            setValue('order', response.data.order);
            setRowVersion(response.data.rowVersion);
            setFileIdUpdate(response.data.fileId);
            setContentData(response.data.content);
            setFileDetailsUpdate(response.data.file);
            setPrimaryKeyEncrypted(response.data.primaryKeyEncrypted);
            setNewsIdUpdate(response.data.NewsId);
            setShowLoader(false);
            accordianStatusHandle('1');
            setPopupAddEdit(true);
            setLoaderApi(false);

        }).catch((error) => {
            setShowLoader(false);
            console.log(error);
        })
    }

    const BlankDetails = () => {
        setIsHeaderSection('');
        setIsEditing(false);
        setValue('Heading', '');
        setValue('Content', '');
        setValue('order', '');
        setValue('file', '');
        setNewsIdUpdate('');
        setRowVersion('');
        setPrimaryKeyEncrypted('')
        setShowLoader(false)
        setFileIdUpdate('');
        setContentData('');
        setFileDetailsUpdate('');
    }

    const accordianStatusHandle = (elem) => {
        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }

    useEffect(() => {
        getNewsList();
        setIsEditing(true);
    }, []);

    const deleteNews = (id) => {
        swal("Are you sure, you want to delete this News?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    setIsEditing(true);
                    formRef.current.reset();
                    await HttpHelper.delete("News/" + id).then((response) => {
                        props.showToast('success', 'News Deleted successfully');
                        getNewsList()
                    }).catch((error) => {
                        props.showToast('error', error.response.data);
                    })
                }
            });
    }

    return (
        <>
            <DashboardWrapper>
                <ToastContainer />
                <div className="DashboardWrapperChild">
                    <Sidebar />
                    <div className="contentWrapper">
                        <HeaderDashboard title="News" />
                        <div className="container-fluid mt-80 p-0">
                            <div className="row">
                                {hasAddPermissionUser == true ? <div className="col-auto">
                                    {isEditing === true ? <button onClick={() => {
                                        setPopupAddEdit(true);
                                        BlankDetails();
                                        accordianStatusHandle('1');
                                    }} className="btn btnSave">Add News</button> : ''}
                                </div> : ''}
                                <div className="col-md-12 mb-2">
                                </div>

                                {hasAddPermissionUser == true && loaderApi == false ? <div className="col-md-12 mb-2 table-responsive">
                                    <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign">
                                        <table className="table tableCustomized table-striped">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        News Title
                                                    </th>
                                                    <th>
                                                        Type
                                                    </th>
                                                    <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                        Image
                                                    </th>
                                                    <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    news.length > 0 && news.map((elem, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{elem.heading}</td>
                                                                <td>{elem.isHeaderSection ? 'Header Section' : 'News'}</td>
                                                                <td style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                                    {
                                                                        elem.file && elem.file.fileUrl ? < img src={elem.file.fileUrl} width="30" height="30" /> : null
                                                                    }
                                                                </td>
                                                                <td style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                                    {hasEditPermissionUser == true ? <CiEdit onClick={() => { getNews(elem.newsId) }} /> : ''}
                                                                    {(hasDeletePermissionUser == true && !elem.isHeaderSection) ? <AiOutlineDelete onClick={() => { deleteNews(elem.primaryKeyEncrypted) }} /> : ''}
                                                                </td>
                                                            </tr>);
                                                    })
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                        <g fill="none" fill-rule="evenodd">
                                            <g transform="translate(1 1)" stroke-width="2">
                                                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                                    <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`popupWrapperImage ${showImgPopup === true ? 'd-flex' : 'd-none'}`}>
                    <div className="crossPopup" onClick={() => {
                        setShowImgPopup(false);
                        setImageCurrentShow('');
                    }}>
                        <RxCross1 />
                    </div>
                    <img src={imageCurrentShow} />
                </div>

                {hasEditPermissionUser || hasAddPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
                    <div className="popupEditAndAddForm">
                        <div className="popupEditAndAddFormCloseButton" onClick={() => {
                            setPopupAddEdit(false);
                            setIsEditing(true);
                        }} >
                            <RxCross2 />
                        </div>

                        {loaderApi == true ? <div className="loaderApi">
                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                <g fill="none" fill-rule="evenodd">
                                    <g transform="translate(1 1)" stroke-width="2">
                                        <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                        <path d="M36 18c0-9.94-8.06-18-18-18">
                                            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                        </path>
                                    </g>
                                </g>
                            </svg>
                        </div> : <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                            <div className="cardBox">
                                <h4>{isEditing === true ? "Update News" : "Create News"}</h4>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>News Title :< span class="requiredAstric"> *</span> </label>
                                        <input type="text"  {...register("Heading", { required: true })} className="border mb-2" placeholder="Heading" aria-invalid={errors.Heading ? "true" : "false"} />
                                        {errors.Heading?.type === 'required' && <p className="text-danger" role="alert">News Title is required</p>}
                                    </div>
                                    <div className={`col-md-12 ${isHeaderSection == 1 ? 'd-none' : ''}`}>
                                        <label>File : {isEditing === true ? < span class="requiredAstric"> *</span> : ''}</label>
                                        <br />
                                        <label>{fileDetailsUpdate != null ? fileDetailsUpdate.originalFileName : ''} </label>
                                        <input type="file" accept="image/png, image/jpeg, image/gif" {...register('file', { required: isEditing === true ? false : true })} className="border mb-2 w-100 is-invalid" />
                                        {errors.file?.type === 'required' && <p className="text-danger" role="alert">Image is required</p>}
                                    </div>

                                    <div className="col-md-12">
                                        <label>Content : < span class="requiredAstric"> *</span></label>
                                        <Editor className="border" placeholder="Content"
                                            tools={[
                                                [Bold, Italic, Underline, Strikethrough],
                                                [Subscript, Superscript],
                                                [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                                [Indent, Outdent],
                                                [OrderedList, UnorderedList],
                                                FontSize, FontName,
                                                FormatBlock,
                                                [Undo, Redo],
                                                [Link, Unlink, ViewHtml],
                                                [InsertTable],
                                                [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
                                                [DeleteRow, DeleteColumn, DeleteTable],
                                                [MergeCells, SplitCell],
                                            ]}
                                            ref={editor}
                                            defaultContent={contentData}
                                            onChange={(e) => {
                                                const regex = /(<([^>]+)>)/gi;
                                                const result = e.html.replace(regex, "");
                                                if (result.length > 0)
                                                    setValue('Content', e.html);
                                                else
                                                    setValue('Content', null);

                                            }}
                                        />
                                        <textarea className="border d-none" {...register("Content", { required: true })} placeholder="Content"></textarea>
                                        {errors.Content?.type === 'required' && <p className="text-danger" role="alert"> Content is required</p>}
                                    </div>
                                    <div className="col-md-12 d-flex justify-content-end mt-3">
                                        <div>
                                            <button className="btn btnSave mt-2">Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>}

                    </div>
                </div> : ''}

            </DashboardWrapper>
        </>
    )
}

export default DashboardNews;